import React from 'react';
import { MARQUEE_ITEMS, HOW_IT_WORKS_STEPS, WHY_STOVESHARE } from '../../constants';

// ─── Marquee Bar ──────────────────────────────────────────────────────────────

export const MarqueeBar = () => (
  <section className="py-8 bg-gradient-to-r from-red-600 via-red-700 to-red-800 overflow-hidden">
    <div className="flex animate-marquee">
      {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
        <div key={i} className="flex items-center whitespace-nowrap text-white text-lg font-medium mx-8">
          <span>{item}</span>
          <div className="w-2 h-2 bg-white rounded-full mx-8" />
        </div>
      ))}
    </div>
  </section>
);

// ─── How It Works ─────────────────────────────────────────────────────────────

export const HowItWorks = () => (
  <section id="how-it-works" className="py-20 bg-gradient-to-br from-gray-50 to-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">How It Works</h2>
        <p className="text-xl text-gray-600">Simple steps to connect kitchens with creators</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {HOW_IT_WORKS_STEPS.map(({ icon: Icon, step, title, desc, gradient }) => (
          <div key={step} className="text-center group">
            <div className={`w-20 h-20 bg-gradient-to-r ${gradient} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
              <Icon className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">{step}. {title}</h3>
            <p className="text-gray-600">{desc}</p>
          </div>
        ))}
      </div>

    </div>
  </section>
);

// ─── Why StoveShare ───────────────────────────────────────────────────────────

export const WhyStoveShare = () => (
  <section id="creators" className="py-20 bg-gradient-to-br from-red-100 to-red-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose StoveShare</h2>
        <p className="text-xl text-gray-600">Everything you need to bring your culinary vision to life</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
        {WHY_STOVESHARE.map(({ title, desc, highlight, icon: Icon, gradient }) => (
          <div key={title} className="text-center p-8 rounded-xl bg-white/80 backdrop-blur-md border border-red-200 hover:bg-white hover:shadow-xl transition-all group">
            <div className={`w-16 h-16 bg-gradient-to-r ${gradient} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
              <Icon className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
            <p className="text-gray-600 mb-4">{desc}</p>
            <div className="inline-block bg-gradient-to-r from-red-100 to-red-200 text-red-700 text-sm font-medium px-4 py-2 rounded-full border border-red-200">
              {highlight}
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);
